const getElementById = (documentRef, elementId) => {
    if (!documentRef || typeof documentRef.getElementById !== 'function') {
        return undefined;
    }

    try {
        return documentRef.getElementById(elementId);
    } catch {
        return undefined;
    }
};

const scrollToTarget = (target, scrollOptions) => {
    if (!target || typeof target.scrollIntoView !== 'function') {
        return false;
    }

    target.scrollIntoView(scrollOptions);
    return true;
};

const scrollAndClickTarget = (target, options = {}) => {
    const didScroll = scrollToTarget(target, options.scrollOptions);
    if (!didScroll) {
        return false;
    }

    if (typeof target.click === 'function') {
        const scheduler = typeof options.scheduler === 'function' ? options.scheduler : setTimeout;
        const delayMs = options.delayMs === undefined ? 500 : options.delayMs;
        scheduler(() => target.click(), delayMs);
    }

    return true;
};

const scrollAndClickElementById = (documentRef, elementId, options) => {
    return scrollAndClickTarget(getElementById(documentRef, elementId), options);
};

module.exports = {
    getElementById,
    scrollAndClickElementById,
    scrollAndClickTarget,
    scrollToTarget
};
